import {AceLoggerService} from '@logging/ace-logger.service';
import {AceLogger} from '@logging/ace-logger';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../base-service';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {MyBuildingsSiteConfig} from './my-buildings-site-config';
import {StringUtils} from '@shared/util/general/string-utils';

export const myBuildingsConfigurationResolver: ResolveFn<MyBuildingsSiteConfig> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<MyBuildingsSiteConfig> => {
  const siteId: number = StringUtils.stringToNumber(route.paramMap.get('id'));
  if (siteId == null) {
    throw new Error('Invalid site id ' + siteId);
  }
  return inject(MyBuildingsConfigurationService).getSiteConfig(siteId);
};

@Injectable()
export class MyBuildingsConfigurationService extends BaseService {

  private readonly logger: AceLogger;
  private DATA_KEY = 'config';
   
  constructor(private http: HttpClient, logService: AceLoggerService) {
    super();
    this.logger = logService.create(MyBuildingsConfigurationService.name);
  }


  getSiteConfig(siteId: number): Observable<MyBuildingsSiteConfig> {
    const options = {headers: this.getHeaders()};
    return this.http.get(this.getGateway() + '/tickets/workorders/config/sites/' + siteId, options).pipe(map(response => {
      if (response[this.DATA_PREFIX]) {
        const config: MyBuildingsSiteConfig = response[this.DATA_PREFIX][this.DATA_KEY];
        if (!config.adapter) {
          config.adapter = {
            config: {}
          };
        } else if (!config.adapter.config) {
          config.adapter.config = {};
        }
        return config;
      } else {
        throw new Error(JSON.stringify(response[this.ERRORS_PREFIX]));
      }
    }));
  }

  updateSiteConfig(siteId: number, config: MyBuildingsSiteConfig): Observable<Object> {
    const options = {headers: this.getHeaders()};
    const body = {
      enabled: config.enabled,
      config: {
        building_id: config.adapter.config.building_id
      }
    };
    return this.http.post(this.getGateway() + '/tickets/workorders/config/sites/' + siteId, body, options);
  }

}
